import React from 'react'
import { UserChip } from '../../../generated/api/chat-room'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { Badge } from '../../common/Badge'
import { ChipAvatar, chipFullName } from './ChipAvatar'

export const READ_BY_PREVIEW_MAX = 5

interface ReceiptPreviewProps {
  messageId: string
  authorId: string
  readers: UserChip[]
  isOwn: boolean
  onClick: () => void
}

export const ReceiptPreview = ({
  messageId,
  authorId,
  readers,
  isOwn,
  onClick,
}: ReceiptPreviewProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const shown = readers.filter((chip) => chip.userId !== authorId)
  const preview = shown.slice(0, READ_BY_PREVIEW_MAX)
  const overflow = shown.length - preview.length

  if (preview.length === 0) return null

  return (
    <button
      type="button"
      className={`mt-1 mb-1 flex items-center gap-0.5 ${
        isOwn ? 'self-end' : 'self-start'
      }`}
      onClick={onClick}
      data-testid={`receipt-preview-${messageId}`}
      title={`${translate('chatMessageReadBy.readBy')} ${preview
        .map(chipFullName)
        .join(', ')}`}
    >
      {overflow > 0 && (
        <Badge
          text={`+${overflow}`}
          className="px-1.5"
          colorClass="bg-neutral-90"
          textColorClass="text-neutral-20"
        />
      )}
      {preview.map((chip) => (
        <ChipAvatar key={chip.userId} chip={chip} size={16} />
      ))}
    </button>
  )
}
